import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ILocale } from '../models/locale/locale.model';
import { IHttpPagedResponse } from '@irembo-andela/irembogov3-common';

@Injectable({
  providedIn: 'root',
})
export class LocaleService {
  private baseUrl = environment.apiGatewayBaseUrl + '/admin/v1';

  constructor(private http: HttpClient) {}

  getSupportedLocales(): Observable<IHttpPagedResponse<ILocale>> {
    return this.http.get<IHttpPagedResponse<ILocale>>(
      `${this.baseUrl}/public/languages?page=0&size=50`
    );
  }
}
